import { Box, Paper, Skeleton } from "@mui/material";
import {
  useDownloadDocumentPreview,
  useGetSDRArtifacts,
} from "src/views/datasets/services/DocumentServices";

import PDFViewer from "src/views/reports/PDFViewer";
import { SearchResult } from "./SourceListItem";

type Props = {
  sdrId: number | null;
  sourceId: number | null;
  responseSources: SearchResult[];
  documentHeight: number;
};

const DocumentSourceDetailView = ({
  sdrId,
  sourceId,
  responseSources,
  documentHeight,
}: Props) => {
  const { data: artifactsInfo = [], isLoading: isArtifactsLoading } =
    useGetSDRArtifacts(sdrId);

  const [firstArtifactInfo] = artifactsInfo;

  const {
    data: fileBlobData,
    isSuccess: fileBlobDataSuccess,
    isLoading: fileBlobDataLoading,
  } = useDownloadDocumentPreview(firstArtifactInfo?.id);

  const source = responseSources.find(
    (source) => source.data_chunk?.id === sourceId,
  );

  const pageNumber = source?.data_chunk?.chunk_metadata.page_number;
  const parsedPageNumber =
    (Array.isArray(pageNumber) ? pageNumber[0] : pageNumber) || 1;

  return (
    <Box
      sx={{
        width: "100%",
        paddingX: 2,
        paddingY: 2,
      }}
    >
      {isArtifactsLoading ||
        (fileBlobDataLoading && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={documentHeight}
            animation="wave"
          />
        ))}
      {fileBlobDataSuccess && (
        <Paper variant="outlined" sx={{ padding: 1, wordWrap: "break-word" }}>
          <PDFViewer
            file={fileBlobData}
            windowHeight={documentHeight}
            pageNum={parsedPageNumber}
          />
        </Paper>
      )}
    </Box>
  );
};

export default DocumentSourceDetailView;
